import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum PageTabEnum {
  pk = 0,
  my = 1,
}
export enum PkStatus {
  ongoing = 0,
  notStarted = 1,
  end = 2,
}

interface unionPkHomepageArg {
  tab: PageTabEnum
  title_offset: InitialStateType['title_offset']
}
export const unionPkHomepage = createAsyncThunk(
  '/live/pk/union_pk_homepage',
  async (arg: unionPkHomepageArg, store) => {
    const resp = await http.post<HiyaRes<Omit<InitialStateType, ''>>>(
      '/live/pk/union_pk_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return {
      ...resp.data.data,
      PageTabIndex: arg.tab,
    }
  }
)

interface unionPkApplyArg {
  // 0；报名 1；取消报名
  action: 0 | 1
  day_offset?: InitialStateType['day_offset']
  start_time?: InitialStateType['start_time']
  round?: InitialStateType['round']
  apply_id?: number
}
export const unionPkApply = createAsyncThunk(
  '/live/pk/union_pk_apply',
  async (arg: unionPkApplyArg, store) => {
    const state = store.getState()
    await http.post<HiyaRes<any>>(
      '/live/pk/union_pk_apply',
      {
        ...state.env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    store.dispatch(
      unionPkHomepage({
        tab: state.UnionPK.PageTabIndex,
        title_offset: state.UnionPK.title_offset,
      })
    )

    return {
      sign_up_status: {0: 2, 1: 1}[
        arg.action
      ] as InitialStateType['sign_up_status'],
    }
  }
)
export enum DayOffsetEnum {
  today = 0,
  tomorrow = 1,
}
export interface PklistType {
  pk_status: PkStatus
  room_id: number
  avatar: string
  name: string
  score: number
  t_room_id: number
  t_avatar: string
  t_name: string
  t_score: number
  start_time: string
}
export interface InitialStateType {
  // 当前tab
  PageTabIndex: PageTabEnum
  union_id?: number
  union_limit?: boolean
  title_offset?: number
  title?: string
  left_more?: boolean
  right_more?: boolean
  // 报名信息
  round?: number
  day_offset?: DayOffsetEnum
  start_time?: string
  // 报名配置
  round_limit?: Array<number>
  st_limit?: Array<[string, string]>
  // 报名状态
  sign_up_status?: number
  typ?: 0 | 1
  // 报名列表
  sign_up_list?: Array<{
    union_id: number
    room_id: number
    avatar: string
    name: string
  }>
  // pk列表
  pk_list?: Array<PklistType>
  // 我的房间
  own?: any[]
  // 我的pk列表
  own_pk_list?: Array<PklistType>
}

const initialState: InitialStateType = {
  PageTabIndex: PageTabEnum.pk,
}

export const UnionPKSlice = createSlice({
  name: 'UnionPK',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(unionPkHomepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(unionPkApply.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default UnionPKSlice.reducer
export const useUnionPKState = () => {
  const data = useSelector((state) => state.UnionPK)
  return data
}
